import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { unsubscriberHelper } from 'src/app/core/helpers/unsubscriber.helper';
import { IonTextItem } from 'src/app/shared/models/components/ion-text-item';
import { get } from 'lodash';
import { IonRadioInputOption } from 'src/app/shared/models/components/ion-radio-input-option';
import { IonRadiosConfig } from 'src/app/shared/models/components/ion-radios-config';
import { BizRadioModal } from '../../../models/components/biz-radio-modal';

@Component({
  selector: 'app-biz-radio-modal',
  templateUrl: './biz-radio-modal.component.html',
  styleUrls: ['./biz-radio-modal.component.scss'],
})
export class BizRadioModalComponent implements OnInit, OnDestroy {
  @Input() config!: IonRadiosConfig;
  @Input() @Input() set options(opts: Array<IonRadioInputOption>) {
    this.opts = opts ? opts : [];
    this.updateItems();
  }
  @Input() checkList!: any;
  @Input() configModal: BizRadioModal;
  list!: any;
  ionicForm: FormGroup;

  isFormSubmitted = false;
  showTextArea = false;

  label: IonTextItem = {
    text: 'Default',
    classes: '',
    slot: 'end',
  };

  textAreaConfig: {
    textAreaLabel: {
      text: 'Alt motiv';
      classes: '';
      slot: '';
    };
    placeholder: 'Scrie aici';
    disabled: false;
  };

  items: Array<{
    id: any;
    label: string;
    disabledStatus: boolean;
  }> = [];

  customRadioForm: FormGroup = this.fb.group({
    radio: ['', [Validators.required]],
    anotherReason: [''],
  });

  public subscriptions = new Subscription();

  private opts: Array<IonRadioInputOption> = [];

  constructor(
    private fb: FormBuilder,
    private modalController: ModalController,
    private cdRef: ChangeDetectorRef
  ) {}
  ngOnInit(): void {}
  closeModal(closeStatus: boolean = true) {
    this.modalController.dismiss({
      dismissed: true,
      radioValue: closeStatus ? null : this.controlValue,
      anotherReason: closeStatus ? null : this.anotherReasonValue,
    });
  }
  checkRadio(event: any) {
    this.toggleRadio(event?.detail?.value);
    if (event?.detail?.value === this.items.length + 1) {
      this.showTextArea = true;
      //  this.customRadioForm.get('anotherReason').setValidators(Validators.required);
    } else {
      this.showTextArea = false;
    }
  }
  get controlI() {
    return this.customRadioForm.get('radio');
  }
  get controlValue() {
    return this.controlI ? this.controlI.value : null;
  }

  get anotherReasonFormControl() {
    return this.customRadioForm.get('anotherReason');
  }
  get anotherReasonValue() {
    return this.anotherReasonFormControl
      ? this.anotherReasonFormControl.value
      : null;
  }
  toggleRadio(data: any) {
    if (this.controlI.disabled) {
      return;
    }
    this.controlI.setValue(data);
    this.cdRef.markForCheck();
  }
  updateItems() {
    const labelK = get(this.config, 'labelKey', 'label');
    const idK = get(this.config, 'idKey', 'id');
    const disabledKey = get(this.config, 'disabledKey', 'disabledStatus');
    this.items = this.opts
      .map((v) => ({
        id: get(v, idK, null),
        label: get(v, labelK, null),
        disabledStatus: get(v, disabledKey, null),
      }))
      .filter((vv) => get(vv, 'id', null) !== null);
    this.cdRef.markForCheck();
  }
  ngOnDestroy(): void {
    unsubscriberHelper(this.subscriptions);
  }
}
